(function () {
  var previewFrameTime = 0.1;

  function setPlayingState(card, isPlaying) {
    var button = card.querySelector("button");
    card.classList.toggle("is-playing", isPlaying);
    if (button) {
      button.setAttribute("aria-label", isPlaying ? "إيقاف الفيديو" : "تشغيل الفيديو");
    }
  }

  function getPreviewTime(video) {
    if (!Number.isFinite(video.duration) || video.duration <= 0) return previewFrameTime;
    return Math.min(previewFrameTime, Math.max(0, video.duration - 0.01));
  }

  function markFrameReady(card) {
    card.classList.add("has-video-frame");
  }

  function waitForRenderedFrame(card, video) {
    if (typeof video.requestVideoFrameCallback === "function") {
      video.requestVideoFrameCallback(function () {
        markFrameReady(card);
      });
      return;
    }

    if (video.readyState >= 2) {
      markFrameReady(card);
      return;
    }

    video.addEventListener("loadeddata", function () {
      markFrameReady(card);
    }, { once: true });
  }

  function showPreviewFrame(card, video) {
    var targetTime = getPreviewTime(video);

    function revealFrameWhenReady() {
      video.pause();
      waitForRenderedFrame(card, video);
      video.removeEventListener("seeked", revealFrameWhenReady);
    }

    video.addEventListener("seeked", revealFrameWhenReady);

    try {
      video.currentTime = targetTime;
      if (Math.abs(video.currentTime - targetTime) < 0.01 && video.readyState >= 2) {
        revealFrameWhenReady();
      }
    } catch (error) {
      video.removeEventListener("seeked", revealFrameWhenReady);
    }
  }

  function preparePreviewFrame(card, video) {
    video.preload = "auto";

    if (video.readyState >= 1) {
      showPreviewFrame(card, video);
    } else {
      video.addEventListener("loadedmetadata", function () {
        showPreviewFrame(card, video);
      }, { once: true });
      video.load();
    }
  }

  function initVariantLinks(root) {
    root.querySelectorAll(".soft-dresses-featured").forEach(function (section) {
      var link = section.querySelector("[data-soft-dresses-variant-link]");
      if (!link) return;

      section.querySelectorAll("[data-soft-dresses-variant-input]").forEach(function (input) {
        if (input.dataset.softDressesVariantReady) return;
        input.dataset.softDressesVariantReady = "true";

        input.addEventListener("change", function () {
          if (input.checked && input.dataset.productUrl) {
            link.setAttribute("href", input.dataset.productUrl);
          }
        });
      });
    });
  }

  function init(root) {
    initVariantLinks(root);

    root.querySelectorAll("[data-soft-dresses-live-card]").forEach(function (card) {
      if (card.dataset.softDressesFeaturedReady) return;
      var video = card.querySelector("video");
      var button = card.querySelector("button");
      if (!video || !button) return;

      card.dataset.softDressesFeaturedReady = "true";
      preparePreviewFrame(card, video);

      card.addEventListener("click", function (event) {
        if (event.target.closest("a")) return;

        if (!video.paused && !video.ended) {
          video.pause();
          return;
        }

        video.defaultMuted = false;
        video.muted = false;
        video.volume = 1;
        video.controls = false;
        if (video.readyState === 0) video.load();
        waitForRenderedFrame(card, video);

        var promise = video.play();
        if (promise) {
          promise.catch(function () {
            video.controls = true;
          });
        }
      });

      video.addEventListener("play", function () {
        setPlayingState(card, true);
      });

      video.addEventListener("pause", function () {
        setPlayingState(card, false);
      });

      video.addEventListener("ended", function () {
        card.classList.remove("has-video-frame");
        showPreviewFrame(card, video);
        setPlayingState(card, false);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
